import { render, staticRenderFns } from "./CSUserStatPanel.vue?vue&type=template&id=3349bbba&scoped=true&lang=pug&"
import script from "./CSUserStatPanel.vue?vue&type=script&lang=js&"
export * from "./CSUserStatPanel.vue?vue&type=script&lang=js&"
import style0 from "./CSUserStatPanel.vue?vue&type=style&index=0&id=3349bbba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3349bbba",
  null
  
)

export default component.exports